var exports = {
  "button": "x52a3aa3b--d077d9--button",
  "button--desktop": "x52a3aa3b--d077d9--button--desktop",
  "button--unread": "x52a3aa3b--d077d9--button--unread",
  "button--desktop--unread": "x52a3aa3b--d077d9--button--desktop--unread",
};

module.exports = exports;
